/**
 * USP Shipping ETA
 * Detects user country via Shopify browsing context (same as geo-redirect popup)
 * and displays estimated delivery time next to the Free Shipping USP.
 *
 * Config is read from a single data attribute:
 *   data-eta-rules="US:3-7,CA:5-10,JP:5-10,DE:7-14,..."
 *   data-eta-default="10-20"
 *
 * If the detected country is not in the rules, the default value is used.
 */
(function () {
  'use strict';

  // ---- Shopify browsing context (reuse geo-redirect cache) ----
  var CACHE_KEY = 'geo_browsing_context';
  var CACHE_EXPIRY = 'geo_browsing_context_expiry';

  function getCachedContext() {
    try {
      var expiry = sessionStorage.getItem(CACHE_EXPIRY);
      if (expiry && new Date() < new Date(expiry)) {
        var cached = sessionStorage.getItem(CACHE_KEY);
        if (cached) return JSON.parse(cached);
      }
    } catch (e) { /* silent */ }
    return null;
  }

  function setCachedContext(data) {
    try {
      var expiry = new Date();
      expiry.setHours(expiry.getHours() + 1);
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(data));
      sessionStorage.setItem(CACHE_EXPIRY, expiry.toISOString());
    } catch (e) { /* silent */ }
  }

  function extractCountry(data) {
    if (data && data.detected_values && data.detected_values.country) {
      var c = data.detected_values.country;
      return (typeof c === 'object' ? c.handle : c).toUpperCase();
    }
    return '';
  }

  function fetchCountry(callback) {
    var cached = getCachedContext();
    if (cached) { callback(extractCountry(cached)); return; }

    fetch('/browsing_context_suggestions.json')
      .then(function (r) {
        if (!r.ok) throw new Error('fetch failed');
        return r.json();
      })
      .then(function (data) {
        setCachedContext(data);
        callback(extractCountry(data));
      })
      .catch(function () {
        var el = document.querySelector('[data-usp-shipping-eta]');
        callback(el ? (el.getAttribute('data-fallback-country') || '') : '');
      });
  }

  // ---- Parse helpers ----

  /** Parse "3-7" → {min:3, max:7} or null */
  function parseRange(str) {
    if (!str) return null;
    var p = str.trim().split('-');
    if (p.length !== 2) return null;
    var min = parseInt(p[0], 10);
    var max = parseInt(p[1], 10);
    return (isNaN(min) || isNaN(max)) ? null : { min: min, max: max };
  }

  /**
   * Parse rules string "US:3-7,CA:5-10,JP:5-10"
   * → { US:{min:3,max:7}, CA:{min:5,max:10}, ... }
   */
  function parseRules(rulesStr) {
    var map = {};
    if (!rulesStr) return map;
    var entries = rulesStr.split(',');
    for (var i = 0; i < entries.length; i++) {
      var parts = entries[i].trim().split(':');
      if (parts.length !== 2) continue;
      var code = parts[0].trim().toUpperCase();
      var range = parseRange(parts[1]);
      if (code && range) map[code] = range;
    }
    return map;
  }

  // ---- Date helpers ----

  function addCalendarDays(start, days) {
    var date = new Date(start);
    date.setDate(date.getDate() + days);
    return date;
  }

  function formatDate(date, lang) {
    if (lang === 'ja') {
      return (date.getMonth() + 1) + '月' + date.getDate() + '日';
    }
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
                  'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return months[date.getMonth()] + ' ' + date.getDate();
  }

  // ---- Main ----

  function renderETA(countryCode) {
    var el = document.querySelector('[data-usp-shipping-eta]');
    if (!el) return;

    var rules = parseRules(el.getAttribute('data-eta-rules'));
    var fallback = parseRange(el.getAttribute('data-eta-default')) || { min: 7, max: 21 };

    var eta = rules[countryCode] || fallback;

    var now = new Date();
    var earliest = addCalendarDays(now, eta.min);
    var latest = addCalendarDays(now, eta.max);

    var htmlLang = (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
    var text;
    if (htmlLang === 'ja') {
      text = 'お届け予定: ' + formatDate(earliest, 'ja') + ' ~ ' + formatDate(latest, 'ja');
    } else {
      text = 'Est. delivery: ' + formatDate(earliest, 'en') + ' - ' + formatDate(latest, 'en');
    }

    var spans = document.querySelectorAll('.usp-shipping-eta');
    for (var i = 0; i < spans.length; i++) {
        spans[i].textContent = text;
        spans[i].style.display = '';
    }
  }

  // ---- Mobile Table Overlap Fix (e.g. for Shipping Policy Modal) ----
  function injectTableCSS() {
    var id = 'usp-table-responsive-css';
    if (document.getElementById(id)) return;
    var css =
      "@media (max-width: 768px) {\n" +
      "  #t4s-pr-popup__shipping-policy table, #t4s-pr-popup__refund-policy table {\n" +
      "    display: block !important;\n" +
      "    width: 100% !important;\n" +
      "    overflow-x: auto !important;\n" +
      "    -webkit-overflow-scrolling: touch;\n" +
      "  }\n" +
      "  #t4s-pr-popup__shipping-policy th, #t4s-pr-popup__shipping-policy td, #t4s-pr-popup__refund-policy th, #t4s-pr-popup__refund-policy td {\n" +
      "    white-space: nowrap !important;\n" +
      "  }\n" +
      "}";
    var style = document.createElement('style');
    style.id = id;
    style.innerHTML = css;
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { 
      fetchCountry(renderETA); 
      injectTableCSS();
    });
  } else {
    fetchCountry(renderETA);
    injectTableCSS();
  }
})();
